<template>
  <div class="main-el">
    <v-text-field class="element" v-model="shtime['name']" type="number" label="Номер урока" outlined dense/>
      <v-menu ref="menuStart" v-model="menuStart" :close-on-content-click="false" :nudge-right="40"
              :return-value.sync="shtime['timeStart']" transition="scale-transition" offset-y
              max-width="290px" min-width="290px">
          <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="shtime['timeStart']" label="Начало урока" outlined dense
                            prepend-inner-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on"/>
          </template>
          <v-time-picker v-if="menuStart" v-model="shtime['timeStart']" full-width format="24hr"
                         @click:minute="$refs.menuStart.save(shtime['timeStart'])"/>
      </v-menu>
      <v-menu ref="menuEnd" v-model="menuEnd" :close-on-content-click="false" :nudge-right="40"
              :return-value.sync="shtime['timeEnd']" transition="scale-transition" offset-y
              max-width="290px" min-width="290px">
          <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="shtime['timeEnd']" label="Конец урока" outlined dense
                            prepend-inner-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on"/>
          </template>
          <v-time-picker v-if="menuEnd" v-model="shtime['timeEnd']" full-width format="24hr"
                         @click:minute="$refs.menuEnd.save(shtime['timeEnd'])"/>
      </v-menu>
      <v-btn icon color="red" @click="$emit('delete', shtime)">
          <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
  </div>
</template>

<script>
export default {
    name: "ShiftTimeSelect",
    props: {
        shtime: Object
    },
    data () {
        return {
            menuStart: false,
            menuEnd: false
        }
    }
}
</script>

<style scoped>
.main-el{
    display: flex;
    flex-direction: row;
    gap: 8px;
    flex-wrap: nowrap;
}
.element{
    width: 30%;
}
</style>
